import content from './Content'
import notFound from './NotFound'
import page from './Page'
import webContent from './WebContent'
import videoContent from './VideoContent'
import pdfContent from './PDFContent'

export const Content = content
export const NotFound = notFound
export const Page = page
export const WebContent = webContent
export const VideoContent = videoContent
export const PDFContent = pdfContent
